module.exports = __webpack_public_path__ + "static/img/lgs.5781eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lgs.png
// module id = 8Qnz
// module chunks = 1